import {ReactNode} from "react";
import styled from "styled-components";
import {ButtonProps} from "@FRAMEWORK/ui/types/d";

interface Props extends ButtonProps {
	children: ReactNode;
	onClick?: () => void;
}

const Button = styled.button`
	display: flex;
	width: 100%;
	height: 50px;
	background-color: var(--disabled-color);
	font-size: 14px;
	font-family: "Noto_m";
	color: var(--emp-color);
	justify-content: center;
	align-items: center;

	em {
		position: relative;
		padding-right: 20px;
		font-family: "PT-medium";

		&:after {
			position: absolute;
			right: 3px;
			top: 3px;
			display: block;
			width: 8px;
			height: 8px;
			border-top: 1px solid var(--emp-color);
			border-right: 1px solid var(--emp-color);
			font-size: 0px;
			transform: rotate(135deg);
			content: "";
		}
	}
`;

const ListMoreButton = ({children, onClick}: Props) => (
	<Button onClick={onClick}>
		<em>{children}</em>
	</Button>
);

export default ListMoreButton;
